function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_u47sdLBqMGo7QUR731i11LNk4HmDmn2v"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_u47sdLBqMGo7QUR731i11LNk4HmDmn2v)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_senqvr7VbFzZds29F8609vLlay8CFWXX"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  transform: "matrix(1,0,0,1,0,0)",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_senqvr7VbFzZds29F8609vLlay8CFWXX)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_koQRomOtfoVVFAnK0wfVvPzX7iCsoB4D"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  transform: "matrix(1,0,0,1,0,0)",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_koQRomOtfoVVFAnK0wfVvPzX7iCsoB4D)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: " M 56.629 22.316 C 33.274 23.708 14.136 39.324 10.571 59.892 C 7.006 80.456 19.974 100.472 41.777 108.048 C 63.575 115.625 88.371 108.736 101.438 91.472 C 114.51 74.208 112.354 51.192 96.253 36.089 C 94.46 34.292 94.592 31.56 96.549 29.908 C 98.51 28.256 101.586 28.284 103.507 29.972 C 122.881 48.133 125.442 75.828 109.661 96.556 C 93.884 117.285 64.011 125.468 37.847 116.229 C 11.684 106.992 -3.733 82.816 0.78 58.112 C 5.298 33.408 28.533 14.82 56.641 13.424 L 56.641 0 L 89.963 17.772 L 56.629 35.548 L 56.629 22.316 Z ",
  fill: "rgb(102,102,102)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 75.859 77.035 C 68.241 77.035 63.691 72.374 63.691 64.546 C 63.691 56.719 68.241 52.156 75.859 52.156 C 83.481 52.156 88 56.809 88 64.607 C 88 72.404 83.459 77.035 75.859 77.035 Z  M 75.859 55.682 C 71.788 55.682 69.454 58.92 69.454 64.566 C 69.454 70.334 71.734 73.516 75.859 73.516 C 79.984 73.516 82.241 70.338 82.241 64.566 C 82.237 58.924 79.912 55.69 75.859 55.69 L 75.859 55.682 Z  M 44.841 77.035 C 41.979 77.311 39.09 76.701 36.851 75.346 C 34.612 73.995 33.219 72.015 33 69.873 L 38.459 69.873 C 38.701 72.064 41.218 73.471 44.89 73.471 C 48.558 73.471 51.098 71.914 51.098 69.675 C 51.098 67.369 48.666 65.928 44.756 65.928 L 40.721 65.928 L 40.721 62.649 L 44.613 62.649 C 45.992 62.757 47.372 62.435 48.41 61.754 C 49.454 61.073 50.063 60.099 50.094 59.07 C 50.094 56.966 47.945 55.604 44.613 55.604 C 43.206 55.495 41.8 55.82 40.725 56.503 C 39.65 57.188 38.996 58.164 38.92 59.216 L 33.618 59.216 C 33.734 57.142 35.01 55.2 37.138 53.86 C 39.265 52.519 42.051 51.902 44.823 52.156 C 50.976 52.156 55.621 54.874 55.621 58.483 C 55.796 61.11 53.341 63.435 49.861 63.929 L 49.861 64.21 C 53.927 64.352 57.076 66.916 56.897 69.941 C 56.897 73.987 51.716 77.035 44.841 77.035 Z ",
  fill: "rgb(102,102,102)"
})))))))));

var SvgForward2 = function SvgForward2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 120 120",
    width: "40px",
    height: "40px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForward2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forward2.17d1c2f0.svg";
export { ForwardRef as ReactComponent };